<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">联系我们</div>
        <div class="item_small">-CONTACT US-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">CONTACT</div>
          <div class="primary_color_text">INFORMATION</div>
        </div>
        <div class="top_text_box_two">联系方式</div>
      </div>
      <div class="concationBox acea-row row-center-wrapper">
        <div class="item_box acea-row">
          <div class="icon_box">
            <img src="@/assets/concatUs/icon/dianhua.png" class="icon_img" />
          </div>
          <div style="flex-wrap: nowrap;" class="info_list acea-row row-column">
            <div class="title">联系电话</div>
            <div class="item">座机: 020-82171366</div>
            <div class="item">传真: 020-82171161</div>
            <div class="item">手机: 13929554918（陈先生）</div>
          </div>
        </div>
        <div class="item_box acea-row">
          <div class="icon_box">
            <img src="@/assets/concatUs/icon/duanxin.png" class="icon_img" />
          </div>
          <div class="info_list acea-row row-column">
            <div class="title">邮箱</div>
            <div class="item">GZPS1366@163.com</div>
          </div>
        </div>
        <div style="border: none" class="item_box acea-row">
          <div class="icon_box">
            <img src="@/assets/concatUs/icon/dizhi.png" class="icon_img" />
          </div>
          <div class="info_list acea-row row-column">
            <div class="title">地址</div>
            <div class="item">广州市增城区新塘镇夏埔环保工业园环保二路3号</div>
          </div>
        </div>
      </div>
      <img class="location_img" src="@/assets/concatUs/locationbg.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Profile",
  data() {
    return {
      topHeaderImg: require("@/assets/contact/contact_bg1.png"),
    };
  },
};
</script>
<style scoped>
.content_box {
  width: 100%;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 4%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  font-weight: bolder;
  color: #7f7f7f;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}
.concationBox .item_box {
  border-right: solid #e6e5e5 1px;
  padding-right: 40px;
  margin-right: 30px;
  height: 140px;
}
.concationBox .item_box .icon_box {
  width: 48px;
  height: 48px;
  background-color: #e6e5e5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}
.concationBox .item_box .icon_box .icon_img {
  width: 25px;
  height: 25px;
}
.concationBox .item_box .info_list .title {
  color: #666666;
  font-size: 24px;
  margin-bottom: 10px;
}
.concationBox .item_box .info_list .item {
  color: #666666;
  font-size: 18px;
  margin-bottom: 5px;
}
.location_img {
  width: 60%;
  height: 30%;
  margin: 40px 0px;
}
@media screen and (max-width: 850px) {
  .concationBox {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .concationBox .item_box {
    border: none;
    margin-top: 40px;
  }
  .location_img {
    width: 90%;
    height: 40%;
  }
}
/* 关于我们 end */
</style>


// WEBPACK FOOTER //
// src/views/contact/index.vue